import React, { Component } from 'react'
import { navigateTo } from 'gatsby-link';

class Gdpr extends Component {

    constructor(props) {
        super(props)
        this.state = ({
            consent: true
        })
    }

    componentDidMount() {
        this.setState({ enableAnal: localStorage.getItem('Prowedding_analytics') ? JSON.parse(localStorage.getItem('Prowedding_analytics')) : null })
        const visualizzo = localStorage.getItem('Prowedding_consent') ? JSON.parse(localStorage.getItem('Prowedding_consent')) : true
        if (visualizzo) {
            try {
                this.UIkit = require("uikit/dist/js/uikit");
                this.UIkit.modal('#gdpr').show()
            } catch (e) {
                console.error(e)
            }
        }
    }

    componentWillUnmount() {
        try {
            this.UIkit = require("uikit/dist/js/uikit");
            this.UIkit.modal('#gdpr').hide()
        } catch (e) {
            console.error(e)
        }
    }


    setAcconsento() {
        localStorage.setItem('Prowedding_analytics', true)
        localStorage.setItem('Prowedding_consent', false)
    }

    goPolicy() {
        localStorage.setItem('Prowedding_analytics', true)
        localStorage.setItem('Prowedding_consent', false)
        navigateTo('/professionista/cookie-policy?user=' + this.props.user.userId)
    }

    render() {



        return (
            <div id="gdpr" data-uk-modal="bg-close: false">
                <div className="uk-modal-dialog">
                    <button onClick={this.setAcconsento.bind(this)} className="uk-modal-close-default" type="button" data-uk-close></button>
                    <div className="uk-modal-header">
                        <h3 className="uk-modal-title">Uso dei Cookie</h3>
                    </div>
                    <div className="uk-modal-body">
                        <p className="uk-text-small">In questo sito, facciamo uso di cookie (o tecnologie similari) per memorizzare informazioni nel tuo computer o dispositivo mobile al fine di migliorare la tua esperienza online. I cookie sono piccoli file di testo che ti consentono di navigare in modo efficiente, ricordare le tue preferenze, aiutarci a comprendere la performance del sito e migliorare in generale la tua esperienza di utilizzo.</p>
                        <p className="uk-text-small uk-text-bold">Chiudendo questo messaggio acconsenti all'utilizzo dei cookie in base alle tue (eventuali) preferenze.</p>
                    </div>
                    <div className="uk-modal-footer uk-text-right">
                        <button onClick={this.goPolicy.bind(this)} className="uk-button uk-button-default uk-margin-small-right uk-modal-close">Cookie Policy</button>
                        <button onClick={this.setAcconsento.bind(this)} className="uk-button uk-button-secondary uk-modal-close">Acconsento</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Gdpr



// WEBPACK FOOTER //
// ./src/components/sito/temi/layoutorizzontale/gdpr/index.js